module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.buoyImage) ? _c('div', {
    staticClass: "client-item-box buoy",
    class: {
      'buoy-article': _vm.pageType === 'article'
    },
    style: (_vm.stylObj),
    attrs: {
      "id": 'nofixNav' + _vm.data.nofixNavId + '-' + _vm.data.nofixNavIndex,
      "data-trackdata": _vm.tData
    },
    on: {
      "click": _vm.buoyAction
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.buoyImage
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78b04568"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/buoy.vue
// module id = 663
// module chunks = 1 13